// like !default / !edit / %21viewLogs
import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesPermissionsSchemesRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-permissions-schemes-view',
	path: '/secure/admin/ViewPermissionSchemes([!%]?[\\w]*).jspa',
};
